export default function ComparisonSection() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-6 md:px-10 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-4">
            Why Choose Us
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            Why Choose VigorBuy Spreadsheet?
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto text-sm md:text-base">
            See how VigorBuy Spreadsheet compares to traditional spreadsheet solutions across key dimensions.
          </p>
        </div>

        <div className="overflow-x-auto rounded-xl border border-background-200">
          <table className="w-full min-w-[600px]">
            <thead>
              <tr className="bg-background-100">
                <th className="text-left px-6 py-4 text-sm font-semibold text-foreground-900">Feature</th>
                <th className="text-left px-6 py-4 text-sm font-semibold text-foreground-500">Traditional Spreadsheet</th>
                <th className="text-left px-6 py-4 text-sm font-semibold text-primary-700">VigorBuy Spreadsheet</th>
              </tr>
            </thead>
            <tbody>
              {[
                { feature: 'Ready-made Templates', traditional: 'Limited', vigorbuy: 'Professional templates' },
                { feature: 'Business Workflow', traditional: 'Manual setup required', vigorbuy: 'Optimized & automated' },
                { feature: 'Data Organization', traditional: 'Basic structures', vigorbuy: 'Structured & intuitive' },
                { feature: 'Learning Curve', traditional: 'Medium to steep', vigorbuy: 'Easy & beginner-friendly' },
                { feature: 'Productivity Impact', traditional: 'Average', vigorbuy: 'High — save hours weekly' },
                { feature: 'Team Collaboration', traditional: 'Limited', vigorbuy: 'Seamless sharing' },
                { feature: 'Updates & Support', traditional: 'Varies', vigorbuy: 'Regularly maintained' },
              ].map((row, idx) => (
                <tr key={idx} className={`border-t border-background-200 ${idx % 2 === 0 ? 'bg-background-50' : 'bg-background-100/50'}`}>
                  <td className="px-6 py-4 text-sm font-medium text-foreground-800">{row.feature}</td>
                  <td className="px-6 py-4 text-sm text-foreground-500">{row.traditional}</td>
                  <td className="px-6 py-4 text-sm text-primary-700 font-medium">
                    <span className="inline-flex items-center gap-1">
                      <span className="w-4 h-4 flex items-center justify-center text-primary-500">
                        <i className="ri-check-fill"></i>
                      </span>
                      {row.vigorbuy}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}